import { Button, Dropdown, Menu, message } from "antd";
import moment from "moment";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTdransferLogs, quick_logs } from "../../actions/cards/cards";
import AddFile from "../../assets/icons/add-file.png";
import DelFile from "../../assets/icons/delete-file.png";
import { apis } from "../../config/APIs";
import usePayAxios from "../../config/useAxios";
import useDownloadCSV from "../../config/useDownloadCSV";
import useDownloadPDF from "../../config/useDownloadPDF";
import { amountFormat, hasAccess } from "../../utils";
import BaseCurrency from "../Common/BaseCurrency";
import Table from "../Common/Table/Table";
import PageHeader from "../PageHeader";

const statuses = {
  success: "Approved",
  failed: "Failed",
  pending: "In Progress",
  pending_approval: "Pending approval",
  rejected: "Rejected",
  inprogress: "In Progress",
  closed: "Closed",
  approved: "Approved",
  processed: "Processed",
  processing: "Processing",
};

const statuses_classes = {
  success: "",
  failed: "rejected",
  pending: "pending_approval",
  pending_approval: "pending_approval",
  rejected: "rejected",
  closed: "rejected",
  inprogress: "pending",
  approved: "Approved",
  processed: "Approved",
  processing: "pending",
};

const quick_columns = [
  {
    title: "Transaction Date & Time",
    dataIndex: "Added Date",
    key: "Added Date",
    render: (text, data) => {
      return (
        <div className={`render_common_style status_${data?.Status}`}>
          {text}
        </div>
      );
    },
  },
  // {
  //   title: "Employee Name",
  //   dataIndex: "card",
  //   key: "card",
  //   render: (text) => text?.employee_details?.name,
  // },
  {
    title: "CRN",
    dataIndex: "Card Reference No",
    key: "Card Reference No",
  },
  {
    title: "Wallet Name",
    dataIndex: "Wallet Name",
    key: "Wallet Name",
    // render: (text) => <div>{moment(text).format("DD MMM YYYY")}</div>,
  },
  {
    title: "Loaded Amount",
    dataIndex: "Total Amount of load",
    key: "Total Amount of load",
    render: (text) => (
      <div>
        <BaseCurrency /> {amountFormat(text)}
      </div>
    ),
  },
  {
    title: "Reject Reason",
    dataIndex: "Reject Reason",
    key: "Reject Reason",
  },
  {
    title: "Remarks",
    dataIndex: "Remarks",
    key: "Remarks",
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
    render: (text) => (
      <div className={`status status_${statuses_classes[text]}`}>
        {statuses[text]}
      </div>
    ),
  },
  // {
  //   title: "Action",
  //   dataIndex: "title",
  //   key: "title",
  //   render: (text, record) => (
  //     <>
  //       {record["Success File URL"] && (
  //         <a href={record["Success File URL"]} className="mr1" download>
  //           <img src={AddFile} alt={"success_doc"} width={18} />
  //         </a>
  //       )}
  //       {record["Error File URL"] && (
  //         <a href={record["Error File URL"]} download>
  //           <img src={DelFile} alt={"fail_doc"} width={18} />
  //         </a>
  //       )}
  //     </>
  //   ),
  // },
];

const TransferLog = () => {
  const dispatch = useDispatch();
  const downloadCSV = useDownloadCSV();
  const downloadPDF = useDownloadPDF();
  const {
    onCall: onCallBulkDetail,
    data: dataBulkDetail,
    reset: resetBulkDetail,
  } = usePayAxios({
    api: "/api/admin/bulk-uploads/v1/show",
    method: "get",
    showSuccessMessage: false,
  });
  const { onCall: onCallBulkFileDownload } = usePayAxios({
    api: "api/v1/convertBase",
    method: "get",
  });
  const { onCall: quickDownload, loading: quickLoading } = usePayAxios({
    api: apis.quickDataDownloadAPI,
    method: "get",
  });

  const { onCall: bulkDownload, loading: bulkLoading } = usePayAxios({
    api: apis.bulkDataDownloadAPI,
    method: "get",
  });

  const [selectedKey, setSelectedKey] = useState("");
  const [selectedDateRange, setSelectedDateRange] = useState([]);

  const [isQuick, setIsQuick] = useState(true);

  const [bulkId, setBulkId] = useState(null);
  const tranferlogs = useSelector(
    (state) => state?.cards?.transferLogs?.data?.response,
  );
  const quicklogs = useSelector(
    (state) => state?.cards?.quick_logs?.data?.response,
  );

  const quickTotalRecords = useSelector(
    (state) => state?.cards?.quick_logs?.data?.total_records ?? 0,
  );

  const tranferTotalRecords = useSelector(
    (state) => state?.cards?.transferLogs?.data?.total_records ?? 0,
  );

  const tablLoading = useSelector(
    (state) =>
      state?.cards?.transferLogs?.loading || state?.cards?.quick_logs?.loading,
  );

  React.useEffect(() => {
    dispatch(quick_logs());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRowClick = (_, record) => {
    if (record?.["Bulk Upload Id"]) {
      setBulkId(record?.["Bulk Upload Id"]);
      onCallBulkDetail({
        params: {
          id: record?.["Bulk Upload Id"],
        },
      });
    }
  };

  const columns = [
    {
      title: "Added Date",
      dataIndex: "Added Date",
      key: "Added Date",
      render: (text, data) => {
        return (
          <div className={`render_common_style status_${data?.Status}`}>
            {text}
          </div>
        );
      },
    },
    {
      title: "No...of Cards",
      dataIndex: "Total no of cards",
      key: "Total no of cards",
    },
    {
      title: "Loaded Amount",
      dataIndex: "Total Amount of load",
      key: "Total Amount of load",
      render: (text) => (
        <div>
          <BaseCurrency />
          {text ? amountFormat(text) : 0}
        </div>
      ),
    },
    // {
    //   title: "Reject Reason",
    //   dataIndex: "Reject Reason",
    //   key: "Reject Reason",
    // },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      render: (text) => (
        <div className={`status status_${statuses_classes[text]}`}>
          {statuses[text]}
        </div>
      ),
    },
    {
      title: "Remarks",
      dataIndex: "Remarks",
      key: "Remarks",
    },
    {
      title: "Action",
      dataIndex: "title",
      key: "title",
      render: (text, record) => (
        <>
          {record["Success File URL"] && (
            // <a href={record["Success File URL"]} className="mr1" download>
            <img
              src={AddFile}
              alt={"success_doc"}
              width={18}
              style={{ marginRight: "0.5rem" }}
              onClick={(e) => {
                e.stopPropagation();
                onCallBulkFileDownload({
                  params: {
                    id: record?.batch_id,
                    success: true,
                  },
                }).then((file_base64) => {
                  downloadCSV(
                    file_base64?.response?.base_64,
                    `bulkSuccessTransfer.csv`,
                  );
                });
              }}
            />
            // </a>
          )}
          {record["Error File URL"] && (
            // <a href={record["Error File URL"]} download>
            <img
              src={DelFile}
              alt={"fail_doc"}
              width={18}
              onClick={(e) => {
                e.stopPropagation();
                onCallBulkFileDownload({
                  params: {
                    id: record?.batch_id,
                  },
                }).then((file_base64) => {
                  downloadCSV(
                    file_base64?.response?.base_64,
                    `bulkErrorTransfer.csv`,
                  );
                });
              }}
            />
            // </a>
          )}
        </>
      ),
    },
  ];

  const bulk_detail_columns = [
    {
      title: "Transaction Date & Time",
      dataIndex: "created_at",
      key: "created_at",
      render: (text, data) => {
        return (
          <div className={`render_common_style status_${data?.Status}`}>
            {moment(text).format("DD-MM-YYYY, HH:mm:ss")}
          </div>
        );
      },
    },
    {
      title: "Employee Name",
      dataIndex: "card",
      key: "card",
      render: (text) => text?.employee_details?.name,
    },
    {
      title: "CRN",
      dataIndex: "card",
      key: "card",
      render: (text) => <div>{text?.card_reference_no}</div>,
    },
    {
      title: "Wallet Name",
      dataIndex: "list_of_wallets_and_topup_amount",
      key: "list_of_wallets_and_topup_amount",
      render: (text) => (
        <div>
          {(text || [])
            .map((textEle) => textEle?.walletKeyIdentifier || "")
            .filter(Boolean)
            .join(", ")}
        </div>
      ),
    },
    {
      title: "Loaded Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => (
        <div>
          <BaseCurrency /> {amountFormat(text)}
        </div>
      ),
    },
    {
      title: "Reject Reason",
      dataIndex: "reject_reason",
      key: "reject_reason",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <div className={`status status_${statuses_classes[text]}`}>
          {statuses[text]}
        </div>
      ),
    },
    // {
    //   title: "Remarks",
    //   dataIndex: "Remarks",
    //   key: "Remarks"
    // },
  ];

  const items = [
    { key: "", label: "All" },

    { key: "weekly", label: "Last 7 days" },
    { key: "monthly", label: "Last 30 days" },
    { key: "quarterly", label: "Last 3 months" },
    { key: "annually", label: "Last Year" },
  ];

  const menu = (
    <Menu
      onClick={(e) => {
        const today = moment();
        let dates = [];
        switch (e.key) {
          case "weekly":
            dates = [
              today.clone().subtract(1, "week").format("YYYY-MM-DD"),
              today.clone().format("YYYY-MM-DD"),
            ];
            break;
          case "monthly":
            dates = [
              today.clone().subtract(1, "month").format("YYYY-MM-DD"),
              today.clone().format("YYYY-MM-DD"),
            ];
            break;
          case "quarterly":
            dates = [
              today.clone().subtract(90, "days").format("YYYY-MM-DD"),
              today.clone().format("YYYY-MM-DD"),
            ];
            break;
          case "annually":
            dates = [
              today
                .clone()
                .subtract(1, "year")
                .startOf("year")
                .format("YYYY-MM-DD"),
              today
                .clone()
                .subtract(1, "year")
                .endOf("year")
                .format("YYYY-MM-DD"),
            ];
            break;
          default:
            dates = [null, null];
            break;
        }

        setSelectedKey(e.key);
        if (e.key !== "custom") {
          setSelectedDateRange(dates);
          if (isQuick) {
            dispatch(
              quick_logs({
                period: e.key,
                start_date: dates[0] ? dates[0] : null,
                end_date: dates[1] ? dates[1] : null,
              }),
            );
          } else {
            dispatch(
              getTdransferLogs({
                period: e.key,
                start_date: dates[0] ? dates[0] : null,
                end_date: dates[1] ? dates[1] : null,
              }),
            );
          }
        } else {
          setSelectedDateRange([]);
        }
      }}
      items={[...items]}
    />
  );

  const is_admin = useSelector(
    (state) => state?.auth?.localVariables?.is_admin,
  );

  return (
    <>
      <div className="heading-div">
        <PageHeader
          title={`Transfer Log`}
          navigation={
            is_admin === "corporate"
              ? {}
              : {
                Home:
                  hasAccess("dashboard", "read") ||
                    hasAccess("dashboard", "write")
                    ? "/dashboard"
                    : "",
                "Transfer Log": "/transfers/quick-transfers/",
              }
          }
        />
      </div>
      <Table
        rowKey="id"
        className={isQuick || dataBulkDetail?.status ? "admin cards" : ""}
        columns={
          isQuick
            ? quick_columns
            : dataBulkDetail?.status
              ? bulk_detail_columns
              : columns
        }
        handleBack={() => {
          resetBulkDetail({});
          setIsQuick(false);
          setBulkId(null);
        }}
        data={
          isQuick
            ? quicklogs
            : dataBulkDetail?.status
              ? dataBulkDetail?.response?.data?.topups
              : tranferlogs
        }
        loading={tablLoading}
        isTopFilter={true}
        scroll={{ x: "max-content" }}
        filter={true}
        isSearch={true}
        isMore={true}
        pagination={{
          showTotal: (total, range) => {
            return `Showing ${range[0]} to ${range[1]} of ${total} entries`;
          },
          total: isQuick
            ? quickTotalRecords
            : dataBulkDetail?.status
              ? dataBulkDetail?.total_records
              : tranferTotalRecords,
          showSizeChanger: false,
          // onChange: (page) => {
          //   if (isQuick) {
          //     dispatch(quick_logs({ page: page }));
          //   } else {
          //     dispatch(getTdransferLogs({ page: page }));
          //   }
          // },
          onChange: (page) => {
            if (isQuick) {
              dispatch(quick_logs({ page: page }));
            } else if (dataBulkDetail?.status) {
              const idToUse =
                bulkId ||
                dataBulkDetail?.response?.id ||
                dataBulkDetail?.response?.data?.id ||
                dataBulkDetail?.response?.data?.batch_id; // fallback attempts
              if (idToUse) {
                onCallBulkDetail({
                  params: {
                    id: idToUse,
                    page,
                  },
                });
              } else {
                // fallback: dispatch transferLogs so UI doesn't break
                dispatch(getTdransferLogs({ page: page }));
              }
            } else {
              dispatch(getTdransferLogs({ page: page }));
            }
          },
        }}
        btnsComponent={
          <>
            <Button
              style={{ fontWeight: 500, fontSize: "0.9rem" }}
              className={`${isQuick ? "formButton" : "cancelButton"} mt1`}
              onClick={() => {
                resetBulkDetail({});
                setIsQuick(true);
                dispatch(
                  quick_logs({
                    period: selectedKey,
                    start_date: selectedDateRange[0]
                      ? selectedDateRange[0]
                      : null,
                    end_date: selectedDateRange[1]
                      ? selectedDateRange[1]
                      : null,
                  }),
                );
              }}
            >
              Quick Load
            </Button>
            <Button
              style={{ fontWeight: 500, fontSize: "0.9rem" }}
              className={`mr1 ml1 mt1 ${!isQuick ? "formButton" : "cancelButton"
                }`}
              onClick={() => {
                resetBulkDetail({});
                setIsQuick(false);
                dispatch(
                  getTdransferLogs({
                    period: selectedKey,
                    start_date: selectedDateRange[0]
                      ? selectedDateRange[0]
                      : null,
                    end_date: selectedDateRange[1]
                      ? selectedDateRange[1]
                      : null,
                  }),
                );
              }}
            >
              Bulk Transfers
            </Button>
          </>
        }
        handleRowClick={handleRowClick}
        hasExport={true}
        hasBack={dataBulkDetail?.status}
        onExport={(val) => {
          if (isQuick)
            quickDownload({ params: { format: val?.toLowerCase() } }).then(
              (res) => {
                // if (res.status) window.open(res?.response, "_blank");
                if (res.status) {
                  if (val === "CSV") {
                    downloadCSV(res?.response, `quick_transfer_log.csv`);
                  } else {
                    downloadPDF(res?.response, `quick_transfer_log.pdf`);
                  }
                }
              },
            );
          else {
            bulkDownload({ params: { format: val?.toLowerCase() } }).then(
              (res) => {
                // if (res.status) window.open(res?.response, "_blank");
                if (res.status) {
                  if (val === "CSV") {
                    downloadCSV(res?.response, `bulk_transfer_log.csv`);
                  } else {
                    downloadPDF(res?.response, `bulk_transfer_log.pdf`);
                  }
                }
              },
            );
          }
        }}
        addNewBtn={() => (
          <Dropdown overlay={menu} trigger={["click"]} className="mr1">
            <Button className="transaction-filter-dropdown">
              {selectedKey
                ? items.find((item) => item.key === selectedKey)?.label
                : "Select"}
            </Button>
          </Dropdown>
        )}
        exportLoading={quickLoading || bulkLoading}
      />
    </>
  );
};

export default TransferLog;
